var map = {
	"./LN.vue": [
		7266,
		266
	],
	"./arrow.vue": [
		6441,
		441
	],
	"./back.vue": [
		5908,
		908
	],
	"./close.vue": [
		3364,
		364
	],
	"./curriculo.vue": [
		4979,
		979
	],
	"./dev.vue": [
		3667,
		667
	],
	"./email.vue": [
		7730,
		730
	],
	"./front.vue": [
		2640,
		640
	],
	"./github.vue": [
		8369,
		894
	],
	"./index.vue": [
		9023
	],
	"./linkdin.vue": [
		4925,
		925
	],
	"./menuMobile.vue": [
		5369,
		369
	],
	"./mobile.vue": [
		8514,
		514
	],
	"./tagLeft.vue": [
		6710,
		710
	],
	"./tagRight.vue": [
		8430,
		430
	],
	"./warn.vue": [
		3212,
		212
	],
	"./work.vue": [
		7125,
		125
	],
	"./world.vue": [
		8086,
		86
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 883;
module.exports = webpackAsyncContext;